import { render, staticRenderFns } from "./ModalStores.vue?vue&type=template&id=f37ba1a8&scoped=true"
import script from "./ModalStores.vue?vue&type=script&lang=js"
export * from "./ModalStores.vue?vue&type=script&lang=js"
import style0 from "./ModalStores.vue?vue&type=style&index=0&id=f37ba1a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37ba1a8",
  null
  
)

export default component.exports